import { drfRequest } from '@/services/drfRequest'

const BASE = '/api/v1/agent-notices'

export interface AgentNoticePolicy {
  activo: boolean
  umbral_confianza: number
  plantilla_nombre: string
  plantilla_idioma: string
  phone_number_id_avisos: string
  crear_llamada_pendiente: boolean
  avisar_visita_preagendada: boolean
}

export interface AgentNoticeDecision {
  id: string
  origen: string
  telefono_cliente: string
  id_gestor: string
  id_demanda: string
  avisar: boolean
  motivo: string
  confianza: number | null
  resumen: string
  resultado: string
  id_gestion_creada: string
  error: string
  created_at: string
}

export interface DecisionsPage {
  count: number
  results: AgentNoticeDecision[]
}

export interface DecisionsQuery {
  page?: number
  desde?: string
  resultado?: string
}

class AgentNoticesServiceClient {
  getPolicy() {
    return drfRequest<AgentNoticePolicy>(`${BASE}/policy/`)
  }

  updatePolicy(data: AgentNoticePolicy) {
    return drfRequest<AgentNoticePolicy>(`${BASE}/policy/`, { method: 'PUT', body: JSON.stringify(data) })
  }

  listDecisions(params: DecisionsQuery = {}) {
    const query = new URLSearchParams()
    for (const [key, value] of Object.entries(params)) {
      if (value) query.set(key, String(value))
    }
    const text = query.toString()
    return drfRequest<DecisionsPage>(`${BASE}/decisions/${text ? `?${text}` : ''}`)
  }
}

export const agentNoticesService = new AgentNoticesServiceClient()
